const WORDS = ["Gold", "Diamond", "Silver", "Bridal", "Heritage", "Trust", "Purity", "Craftsmanship"];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative py-8 md:py-10 bg-ivory border-y border-gold/20 overflow-hidden" aria-hidden="true">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {WORDS.map((w) => (
            <span key={`${copy}-${w}`} className="flex items-center">
              <span className="font-serif italic text-3xl md:text-5xl text-royal/25 px-6 md:px-10 whitespace-nowrap">{w}</span>
              <span className="w-1.5 h-1.5 rotate-45 bg-gold/50" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
